/**
 * Magic Link Handler Component
 * Consolidated magic link processing - delegates to UnifiedOTP for consistency
 */
import React from 'react';
import UnifiedOTP from './UnifiedOTP';

const MagicLinkHandler = () => {
    return <UnifiedOTP mode = "magic-link" / > ;
};

export default MagicLinkHandler;